module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('download-Popup'), _vm._v(" "), (_vm.isOperamini) ? _c('p', {
    staticClass: "operamini-tips"
  }, [_vm._v("\n        Untuk memberi Anda pengalaman yang lebih baik, silakan unduh aplikasi profesional kami.\n    ")]) : _vm._e(), _vm._v(" "), _c('navVue', {
    attrs: {
      "subtitleData": _vm.getMatchSubTabList,
      "navSelected": _vm.currentNavTag
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "contentWrap",
    attrs: {
      "id": "contentWrap"
    }
  }, [(_vm.getMatchNoDataMode && !_vm.getMatchLoadingShow) ? _c('nodata', {
    attrs: {
      "whiteMode": true
    }
  }) : _vm._e(), _vm._v(" "), (_vm.getMatchLoadingShow) ? _c('loading') : _vm._e(), _vm._v(" "), (!_vm.getMatchNoDataMode && !_vm.getMatchLoadingShow) ? _c('div', {
    staticClass: "listwrap",
    attrs: {
      "id": "listwrap"
    }
  }, [_vm._l((_vm.getFinalListSplitDateData), function(item, key, index) {
    return _c('div', {
      key: index
    }, [_c('p', {
      staticClass: "dateTit"
    }, [_c('span', [_vm._v(_vm._s(key))]), _vm._v(" "), _c('em', [_vm._v(_vm._s(item.localdate))])]), _vm._v(" "), _vm._l((item), function(elem, index) {
      return _c('div', {
        key: index,
        staticClass: "sameDateData",
        attrs: {
          "id": ("match-" + (elem.match_id))
        }
      }, [_c('div', {
        staticClass: "list"
      }, [_c('div', {
        staticClass: "clearfix",
        on: {
          "click": function($event) {
            _vm.handleJumpMatchDetailPage(elem)
          }
        }
      }, [_c('dl', {
        staticClass: "flwrap"
      }, [_c('dt', [_c('img', {
        directives: [{
          name: "team-logo",
          rawName: "v-team-logo"
        }],
        staticClass: "teamlogo",
        attrs: {
          "data-src": _vm.getImgSrc(elem.team_A_logo)
        }
      })]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(elem.team_A_name))])]), _vm._v(" "), (elem.status === 'Fixture') ? _c('div', {
        staticClass: "unStart_competewrap competewrap"
      }, [_c('div', {
        staticClass: "unStartInfor"
      }, [_c('p', {
        staticClass: "competename"
      }, [_vm._v("\n                                        " + _vm._s(_vm.tran12(elem.localdate.local_hms)) + "\n                                        " + _vm._s(elem.competition_name) + " " + _vm._s(elem.gameweek) + "\n                                    ")]), _vm._v(" "), _c('p', {
        staticClass: "vs"
      }, [_vm._v("vs")]), _vm._v(" "), (elem.live_icon) ? _c('AppMatchTag', {
        attrs: {
          "type": elem.live_icon.type
        }
      }) : _vm._e()], 1)]) : (elem.status === 'Postponed' || elem.status === 'Cancelled' || elem.status === 'Suspended') ? _c('div', {
        staticClass: "unStart_competewrap competewrap"
      }, [_c('div', {
        staticClass: "unStartInfor"
      }, [_c('p', {
        staticClass: "competename"
      }, [_vm._v("\n                                        " + _vm._s(elem.competition_name) + " " + _vm._s(elem.gameweek) + "\n                                        "), _c('span', {
        staticClass: "text-gray"
      }, [_vm._v(_vm._s(elem.status))])]), _vm._v(" "), _c('p', {
        staticClass: "vs"
      }, [_vm._v("vs")]), _vm._v(" "), (elem.live_icon) ? _c('AppMatchTag', {
        attrs: {
          "type": elem.live_icon.type
        }
      }) : _vm._e()], 1)]) : (elem.status === 'Playing') ? _c('div', {
        staticClass: "statusPlaying_competewrap competewrap"
      }, [_c('div', {
        staticClass: "playingUnLive"
      }, [_c('p', {
        staticClass: "competename"
      }, [_vm._v("\n                                        " + _vm._s(elem.competition_name) + " " + _vm._s(elem.gameweek) + "\n                                        "), _c('span', {
        staticClass: "playingUnliveTime"
      }, [_vm._v(_vm._s(elem.playing_time) + "'")])]), _vm._v(" "), _c('p', {
        staticClass: "playingScore"
      }, [_c('span', [_vm._v(_vm._s(elem.fs_A))]), _c('em', {
        staticClass: "dot"
      }, [_vm._v(":")]), _c('span', [_vm._v(_vm._s(elem.fs_B))])]), _vm._v(" "), (elem.live_icon) ? _c('AppMatchTag', {
        attrs: {
          "type": elem.live_icon.type
        }
      }) : _vm._e()], 1)]) : (elem.status === 'Played') ? _c('div', {
        staticClass: "statusEnd_competewrap competewrap"
      }, [_c('p', {
        staticClass: "competename"
      }, [_vm._v("\n                                    " + _vm._s(elem.competition_name) + " " + _vm._s(elem.gameweek) + "\n                                    "), _c('span', {
        staticClass: "status"
      }, [_vm._v("akhir")])]), _vm._v(" "), _c('p', {
        staticClass: "compete-center mb5"
      }, [_c('span', [_vm._v(_vm._s(elem.fs_A))]), _c('em', {
        staticClass: "line"
      }), _c('span', [_vm._v(_vm._s(elem.fs_B))])]), _vm._v(" "), (elem.live_icon) ? _c('AppMatchTag', {
        attrs: {
          "type": elem.live_icon.type
        }
      }) : _vm._e()], 1) : _c('div', {
        staticClass: "text-vs"
      }, [_vm._v("vs")]), _vm._v(" "), _c('dl', {
        staticClass: "frwrap"
      }, [_c('dt', [_c('img', {
        directives: [{
          name: "team-logo",
          rawName: "v-team-logo"
        }],
        staticClass: "teamlogo",
        attrs: {
          "data-src": _vm.getImgSrc(elem.team_B_logo)
        }
      })]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(elem.team_B_name))])])])])])
    })], 2)
  }), _vm._v(" "), (_vm.getDownloadFooterShow) ? _c('DownloadFooter', {
    attrs: {
      "text": "Unduh All Sepakbola untuk lebih banyak pertandingan"
    }
  }) : _vm._e()], 2) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bcd3cbc0","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/AppMatch.vue
// module id = 742
// module chunks = 3